import { render } from "./RadialMenu.vue?vue&type=template&id=21fa412b&scoped=true"
import script from "./RadialMenu.vue?vue&type=script&lang=js"
export * from "./RadialMenu.vue?vue&type=script&lang=js"

import "./RadialMenu.vue?vue&type=style&index=0&id=21fa412b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fa412b"]])

export default __exports__